import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useEmployeeAttendanceAuth } from '../../employee-attendance/context/EmployeeAttendanceAuthContext';
import { getPostLoginPath } from '../../employee-attendance/utils/roleAccess';
import { UtilitiesCompanyProvider, useUtilitiesCompany } from '../context/UtilitiesCompanyContext';
import UtilitiesDashboardPage from '../components/UtilitiesDashboardPage';
import UtilitiesListPage from '../components/UtilitiesListPage';
import UtilitiesFormPage from '../components/UtilitiesFormPage';

function PortalLoading() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-slate-700" />
    </div>
  );
}

/** Only users with Utilities access (roles include "utilities") get in. */
function UtilitiesOnlyRoute({ children }) {
  const { isUtilities, isAuthenticated, loading, user } = useEmployeeAttendanceAuth();
  if (loading) return <PortalLoading />;
  if (!isAuthenticated) return <Navigate to="/bu-dashboard/login" replace />;
  if (!isUtilities) return <Navigate to={getPostLoginPath(user)} replace />;
  return children;
}

/** Re-mounts the form when the company changes so no stale data stays on screen. */
function CompanyKeyedForm() {
  const { companyId } = useUtilitiesCompany();
  return <UtilitiesFormPage key={companyId} />;
}

export default function UtilitiesRoutes() {
  return (
    <UtilitiesOnlyRoute>
      <UtilitiesCompanyProvider>
        <Routes>
          <Route path="/dashboard" element={<UtilitiesDashboardPage />} />
          <Route path="/:resource/new" element={<CompanyKeyedForm />} />
          <Route path="/:resource/:id" element={<CompanyKeyedForm />} />
          <Route path="/:resource" element={<UtilitiesListPage />} />
          <Route path="*" element={<Navigate to="/bu-dashboard/utilities/dashboard" replace />} />
        </Routes>
      </UtilitiesCompanyProvider>
    </UtilitiesOnlyRoute>
  );
}
